export default "__VITE_ASSET__DV9JVC75__"